export const BRAND = {
  productName: 'Tenant Hub',
  appTitle: 'Tenant Hub - Super Admin',
  tagline: 'One hub. Many tenants. Zero chaos.',
  supportingLine:
    'Software Applications & Service Management — Create, Deploy, Implement and Manage',
  shortTagline: 'Tenant Hub Super Admin',
  loginTitle: 'Tenant Hub',
  catchPhrase: 'Launch tenants in minutes. Govern them for years.'
};

export const UI_TEMPLATES = [
  {
    id: 'amber-night',
    name: 'Amber Night',
    description: 'Dark navy with amber accents',
    appBar: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    accent: '#f59e0b',
    accentSecondary: '#ef4444',
    drawer: '#0f172a',
    logoGradient: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)'
  },
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    description: 'Teal and deep blue',
    appBar: 'linear-gradient(135deg, #0c4a6e 0%, #0369a1 100%)',
    accent: '#0ea5e9',
    accentSecondary: '#14b8a6',
    drawer: '#0f172a',
    logoGradient: 'linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)'
  },
  {
    id: 'forest-slate',
    name: 'Forest Slate',
    description: 'Emerald on slate',
    appBar: 'linear-gradient(135deg, #14532d 0%, #1e293b 100%)',
    accent: '#22c55e',
    accentSecondary: '#84cc16',
    drawer: '#0f172a',
    logoGradient: 'linear-gradient(135deg, #22c55e 0%, #84cc16 100%)'
  },
  {
    id: 'sunset-coral',
    name: 'Sunset Coral',
    description: 'Warm coral and rose',
    appBar: 'linear-gradient(135deg, #7c2d12 0%, #9f1239 100%)',
    accent: '#f97316',
    accentSecondary: '#fb7185',
    drawer: '#1c1917',
    logoGradient: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)'
  }
];

export const getStoredTemplateId = () =>
  localStorage.getItem('tenanthub_ui_template') || 'amber-night';

export const getTemplateById = (id) =>
  UI_TEMPLATES.find((t) => t.id === id) || UI_TEMPLATES[0];
